// extracted by mini-css-extract-plugin
export default {"Nav_icons":"mobile_Nav_icons__xpT+8"};